import ServiceCard from "./ServiceCard";
import Accordion from "./Accordion";
import Reviews from "./Reviews";
import TeamMemberCard from "./TeamMemberCard";
import ServiceCard3 from "./ServiceCard3";
export { ServiceCard, ServiceCard3, Accordion, Reviews, TeamMemberCard };
